import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { AlignJustify, ChevronDown, X } from 'lucide-react';

// import {
//   ChevrondownSvg,
//   CrossBlackIcon,
//   HamburgerSvg,
//   LogoV2,
// } from "@/src/Asset";

import useExploreMoreHook from '../useExploreMoreHook';

const ExploreMoreMobile = ({
  streamData,
  isBgTransparent,
}: // setShouldDataFetch,
any) => {
  const { streams, handleStreamSelect, selectedStreamIndex, sections } = useExploreMoreHook({ streamData });

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState<number | null>(1);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleStreamSelectWithReset = (streamId: number) => {
    setActiveSection(null); // Close all sections when stream changes
    handleStreamSelect(streamId); // Call original handler
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setHasInteracted(true);
  };

  const toggleSection = (id: number) => {
    setActiveSection((prev) => (prev === id ? null : id));
  };

  // useEffect(() => {
  //   if (isMenuOpen) {
  //     setShouldDataFetch(true);
  //   }
  // }, [isMenuOpen]);

  return (
    <div className="relative lg:hidden">
      <button className="p-1 mt-1" onClick={toggleMenu}>
        {/* <HamburgerSvg
          className={`scale-75 ${
            isBgTransparent ? "text-white" : "text-black"
          }`}
        /> */}
        <AlignJustify className={`size-5 w-4 ${isBgTransparent ? 'text-white' : 'text-black'}`} />
      </button>

      {/* Full-Screen Modal */}
      <div
        className={`fixed inset-0 bg-white z-50 ${
          hasInteracted ? 'transform transition-transform duration-300' : 'transform'
        } ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} flex flex-col`}
      >
        {/* Close Button */}
        <div className="flex flex-row justify-between px-2 z-50">
          <Image
            src="/images/collegehai_logo.png"
            alt="Collegehai logo"
            title="Collegehai logo"
            width={500}
            height={500}
            className={`w-32 lg:w-40 h-8 lg:h-14 object-cover mt-2 -ml-2 lg:ml-0`}
          />
          <button className="py-4 px-4" onClick={toggleMenu} aria-label="Close menu">
            <X className="size-6" aria-hidden="true" />
          </button>
        </div>

        <div className="flex text-start ">
          {/* Streams Sidebar */}
          <div>
            <div className=" bg-gray-100 p-4 overflow-y-auto">
              <ul className="space-y-2">
                {streams.map((stream: any) => (
                  <li key={stream.id}>
                    <button
                      className={`text-xs text-start font-medium ${
                        stream.id === selectedStreamIndex ? 'text-primary' : 'text-gray-700'
                      }`}
                      onClick={() => handleStreamSelectWithReset(stream.id)}
                    >
                      {stream?.stream_name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Sections Dropdowns */}
          <div className="w-2/3 p-4 overflow-y-auto h-[calc(100vh-80px)]">
            {sections?.map(({ id, title, items, key, getUrl, viewAllUrl }) => {
              const limit = id === 1 ? 15 : 6;
              const displayedItems = items?.length > limit ? items.slice(0, limit) : items;

              return (
                displayedItems?.length > 0 && (
                  <div key={id} className="mb-4">
                    <button
                      className="flex justify-between items-center w-full text-left text-xs xxs:text-sm font-semibold text-primary duration-200"
                      onClick={() => toggleSection(id)}
                    >
                      {title}
                      <ChevronDown
                        className={`w-5 transition-transform duration-200 ${activeSection === id ? 'rotate-180' : ''}`}
                      />
                    </button>

                    <div
                      className={`transition-all duration-300 ease-in-out overflow-hidden ${
                        activeSection === id ? 'max-h-[1000px]' : 'max-h-0'
                      }`}
                    >
                      <ul className="mt-2 space-y-1">
                        {displayedItems?.map((item: any) => (
                          <li key={item.id} className="text-xs text-gray-600">
                            <Link href={getUrl(item)}>
                              <button
                                className="text-left w-full hover:text-primary"
                                onClick={() => setIsMenuOpen(false)}
                              >
                                {item[key]}
                              </button>
                            </Link>
                          </li>
                        ))}
                        {items.length > limit && (
                          <li className="mt-2">
                            <Link
                              href={viewAllUrl}
                              className="text-blue-500 text-left text-xs hover:underline"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              View All
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreMoreMobile;
